import BackOrder from "./BackOrder";
import Branches from "./Branches";
import BranchOrders from "./BranchOrders";
import Dashboard from "./Dashboard";
import Parts from "./Parts";
import PublicBackOrder from "./PublicBackOrder";
import SignIn from "./SignIn";
import Groups from "./Groups";
import BackOrderClient from "./BackOrderClient";
import CreateInvoice from "./CreateInvoice";

export {
  BackOrder,
  Branches,
  BranchOrders,
  Dashboard,
  Parts,
  PublicBackOrder,
  SignIn,
  Groups,
  BackOrderClient,
  CreateInvoice,
};

var body = document.body;

  body.classList.add(process.env.REACT_APP_COMPANY);
  document.title = `Rastreo ${process.env.REACT_APP_TITLE}`;

